// src/components/Sidebar.jsx
import React from 'react';
import {
  Home, FileText, User, Mail, Globe, Image, Share2, PhoneCall,
  ShieldCheck, Zap,
} from 'lucide-react';

const QUICK_ACCESS = [
  { type: 'username', icon: User,      label: 'Username',       badge: 'Live' },
  { type: 'email',    icon: Mail,      label: 'Email Address',  badge: 'Safe' },
  { type: 'phone',    icon: PhoneCall, label: 'Phone Number',   badge: null   },
  { type: 'domain',   icon: Globe,     label: 'Domain',         badge: 'Live' },
  { type: 'image',    icon: Image,     label: 'Image / EXIF',   badge: null   },
  { type: 'social',   icon: Share2,    label: 'Social Networks',badge: null   },
];

const Sidebar = ({ currentView, onNavigate, onSearchTypeSelect }) => {
  const navItems = [
    { id: 'home',    icon: Home,     label: 'New Search' },
    { id: 'history', icon: FileText, label: 'History'    },
  ];

  return (
    <aside style={{
      width: 230,
      background: 'rgba(255,255,255,0.035)',
      backdropFilter: 'blur(24px)',
      WebkitBackdropFilter: 'blur(24px)',
      borderRight: '1px solid var(--color-border)',
      padding: '24px 16px',
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      flexShrink: 0,
    }}>
      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '4px 10px', marginBottom: 20 }}>
        <div style={{
          width: 36, height: 36, borderRadius: 10,
          background: 'linear-gradient(135deg, #6366f1, #a855f7)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 0 20px rgba(99,102,241,0.35)',
          fontSize: 18,
        }}>
          🔍
        </div>
        <div>
          <div style={{ fontWeight: 800, fontSize: 15, letterSpacing: '-0.02em' }}>OSINT Hub</div>
          <div style={{ fontSize: 10, color: 'var(--color-text-muted)', fontWeight: 500 }}>
            Intelligence Suite
          </div>
        </div>
      </div>

      {/* Main nav */}
      <nav style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentView === item.id || (item.id === 'home' && currentView !== 'history');
          return (
            <div
              key={item.id}
              className={`nav-item${isActive ? ' active' : ''}`}
              onClick={() => onNavigate(item.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && onNavigate(item.id)}
            >
              <Icon size={15} />
              {item.label}
            </div>
          );
        })}
      </nav>

      <div style={{ height: 1, background: 'var(--color-border)', margin: '12px 0' }} />

      {/* Quick access */}
      <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--color-text-muted)', padding: '0 10px', letterSpacing: '0.08em', marginBottom: 4 }}>
        QUICK ACCESS
      </div>

      <nav style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {QUICK_ACCESS.map((item) => {
          const Icon = item.icon;
          return (
            <div
              key={item.type}
              className="nav-item"
              onClick={() => onSearchTypeSelect(item.type)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && onSearchTypeSelect(item.type)}
              style={{ justifyContent: 'space-between' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                <Icon size={14} />
                <span style={{ fontSize: 12 }}>{item.label}</span>
              </div>
              {item.badge && (
                <span className={`badge ${item.badge === 'Live' ? 'badge-teal' : 'badge-accent'}`}>
                  {item.badge === 'Live' ? <Zap size={8} /> : <ShieldCheck size={8} />}
                  {item.badge}
                </span>
              )}
            </div>
          );
        })}
      </nav>

      {/* Footer */}
      <div style={{ marginTop: 'auto', paddingTop: 16, borderTop: '1px solid var(--color-border)' }}>
        <div style={{
          padding: '12px 14px',
          background: 'rgba(99,102,241,0.08)',
          borderRadius: 'var(--radius-md)',
          border: '1px solid rgba(99,102,241,0.15)',
        }}>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#a5b4fc', lineHeight: 1 }}>100+</div>
          <div style={{ fontSize: 11, color: 'var(--color-text-muted)', marginTop: 2 }}>Platforms Scanned</div>
          <div style={{ fontSize: 10, color: 'var(--color-text-muted)', marginTop: 6, lineHeight: 1.4 }}>
            OTP-safe • Privacy-first
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
